export const BTN_TAIXIU = "BTN_TAIXIU";
export const RANDOM = "RANDOM";
export const TINH_DIEM = "TINH_DIEM";
